module.exports = __webpack_public_path__ + "img/32_25.38b1e37b.png";